//
import AboutHero from '../about-hero';
import AboutWhat from '../about-what';
import AboutTestimonials from '../about-testimonials';

// ----------------------------------------------------------------------

export default function AboutView() {
  return (
    <>
      <AboutHero />

      <AboutWhat />

      <AboutTestimonials />
    </>
  );
}
